import styled from 'styled-components';

const ShareAnywhere = styled.div`
  align-items: center;
  display: flex;
  flex: 0.4;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const ShareLinks = styled.div`
  column-gap: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 40px;
  row-gap: 16px;
`;

const ShareLink = styled.div``;

export { ShareAnywhere, ShareLink, ShareLinks };
